import * as React from 'react';
const PickerContext = /*#__PURE__*/React.createContext(null);
export default PickerContext;